<template>
  <div id="app">
    <router-view v-slot="{ Component }">
      <keep-alive include="app_content">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>
<script setup>
defineOptions({name: 'App'});
</script>

<style lang="stylus">
:root
  color-scheme: light
  --page-bg: #eeeeee
  --surface-bg: #ffffff
  --surface-soft: #f6f6f6
  --section-bg: #f0efed
  --text-main: #111111
  --text-normal: #2c3e50
  --text-secondary: #666666
  --text-muted: #777777
  --text-faint: #999999
  --border-color: #e0e0e0
  --border-strong: #d9d9d9
  --accent-color: #d71920
  --on-accent-color: #ffffff
  --selection-color: #4395ff
  --success-color: #16833a
  --active-bg: #fff8f8
  --disabled-bg: #f1f1f1
  --overlay-bg: rgba(0, 0, 0, 0.5)

@media (prefers-color-scheme: dark)
  :root
    color-scheme: dark
    --page-bg: #0f1115
    --surface-bg: #181b20
    --surface-soft: #20242a
    --section-bg: #242930
    --text-main: #f4f4f5
    --text-normal: #e4e7ec
    --text-secondary: #c2c7d0
    --text-muted: #9aa3af
    --text-faint: #7d8591
    --border-color: #303641
    --border-strong: #3a414d
    --accent-color: #ff5a63
    --on-accent-color: #ffffff
    --selection-color: #69a8ff
    --success-color: #46c978
    --active-bg: #311c20
    --disabled-bg: #252a31
    --overlay-bg: rgba(0, 0, 0, 0.72)

html,
body,
#app
  height 100%
  min-height 100%
  overflow hidden
  background var(--page-bg)
  color var(--text-normal)

input,
textarea,
select,
button
  font-size: 16px
  font-family inherit
</style>
